import {faPencilSimple} from '@awesome.me/kit-d4c1b300b9/icons/kit/custom';
import {forwardRef} from '@chakra-ui/react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {IconButton} from './IconButton';
import type {UIIconButtonProps} from './typings';

export const EditIconButton = forwardRef<UIIconButtonProps, 'button'>((props, ref) => (
  <IconButton size={`xs`} aria-label={`edit`} icon={<FontAwesomeIcon icon={faPencilSimple} />} {...props} ref={ref} />
));
